<template>
  <div class='myTile'>
    <p class='title is-3 is-6-mobile'>and keeps spreading</p>
    <div class='has-text-left'>
      <p>The number of new cases peaked in the first few days of the pandemic, before slowly tapering off. As more users became infected, the rate of infections slowed significantly and "flattened" the curve.</p>
      <br>
      <p class='chartTitle'>Figure 2:  New infections by day</p>
      <hr class='rule'>
    </div>

    <div>
      <GChart
        type="LineChart"
        :data="dailyInfectionLineChart"
        :options="{
          backgroundColor: '#F0F0F0',
          chartArea: {backgroundColor: '#F0F0F0'}, 
          legend: {position: 'none'}, 
          lineWidth: 6,
          series: {0: {color: '#3298DC'}},
          hAxis: {
            format: 'M/d',
            gridlines: {count: -1},
            minorGridlines: {units: {days: {format: 'M/d'}}}
          }
        }"
      ></GChart>
    </div>

    <div class='has-text-left'>
      <br>
      <p class='chartTitle'>Figure 3:  Cumulative infections by day</p>
      <hr class='rule'>
    </div>

    <div>
      <GChart
        type="LineChart"
        :data="cumInfectionLineChart"
        :options="{
          backgroundColor: '#F0F0F0',
          chartArea: {backgroundColor: '#F0F0F0'}, 
          legend: {position: 'none'}, 
          lineWidth: 6,
          series: {0: {color: '#3298DC'}},
          hAxis: {
            format: 'M/d',
            gridlines: {count: -1},
            minorGridlines: {units: {days: {format: 'M/d'}}}
          }
        }"
      ></GChart>
    </div>
  </div>
  
</template>

<script>
import { GChart } from "vue-google-charts";

export default {
  props: ['mobile'],
  data() {
    return {

      dailyInfectionLineChart: [
        ['Date','Number Infections'],
        [new Date(2020,2,20),255],
        [new Date(2020,2,21),3628],
        [new Date(2020,2,22),8136],
        [new Date(2020,2,23),7590],
        [new Date(2020,2,24),7043],
        [new Date(2020,2,25),5816],
        [new Date(2020,2,26),6147],
        [new Date(2020,2,27),5991],
        [new Date(2020,2,28),6097],
        [new Date(2020,2,29),5704],
        [new Date(2020,2,30),5320],
        [new Date(2020,2,31),5138],
        [new Date(2020,3,1),4158],
        [new Date(2020,3,2),4322],
        [new Date(2020,3,3),4088],
        [new Date(2020,3,4),1006],
        [new Date(2020,3,5),3016],
        [new Date(2020,3,6),4563],
        [new Date(2020,3,7),3037],
        [new Date(2020,3,8),3461],
        [new Date(2020,3,9),3629],
        [new Date(2020,3,10),4059],
        [new Date(2020,3,11),4467],
        [new Date(2020,3,12),3475],
        [new Date(2020,3,13),3517],
        [new Date(2020,3,14),3762],
        [new Date(2020,3,15),3509],
        [new Date(2020,3,16),3464],
        [new Date(2020,3,17),2454],
      ],
      cumInfectionLineChart: [
        ['Date','Cumulative Infections'],
        [new Date(2020,2,20),255],
        [new Date(2020,2,21),3883],
        [new Date(2020,2,22),12019],
        [new Date(2020,2,23),19609],
        [new Date(2020,2,24),26652],
        [new Date(2020,2,25),32468],
        [new Date(2020,2,26),38615],
        [new Date(2020,2,27),44606],
        [new Date(2020,2,28),50703],
        [new Date(2020,2,29),56407],
        [new Date(2020,2,30),61727],
        [new Date(2020,2,31),66865],
        [new Date(2020,3,1),71023],
        [new Date(2020,3,2),75345],
        [new Date(2020,3,3),79433],
        [new Date(2020,3,4),80439],
        [new Date(2020,3,5),83455],
        [new Date(2020,3,6),88018],
        [new Date(2020,3,7),91055],
        [new Date(2020,3,8),94516],
        [new Date(2020,3,9),98145],
        [new Date(2020,3,10),102204],
        [new Date(2020,3,11),106671],
        [new Date(2020,3,12),110146],
        [new Date(2020,3,13),113663],
        [new Date(2020,3,14),117425],
        [new Date(2020,3,15),120934],
        [new Date(2020,3,16),124398],
        [new Date(2020,3,17),126852],
      ],
    }
  },
  components: {
    GChart
  }
}


</script>